import "./styles/kestyle.css";
import SectionOne from "./parts/section-one";
import { SectionTwo } from "./parts/section-two";
import { SectionThree } from "./parts/section-three";
import { SectionFour } from "./parts/section-four";
import { SectionFive } from "./parts/section-five";
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
const KEInternational = () => {

  const [navbarVisible, setNavbarVisible] = useState(false);
  const location = useLocation();

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isKwikCheckoutCOD = false; // static flag

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const mobileToggle = () => setNavbarVisible(!navbarVisible);
  const mobileSubMenClose = () => setNavbarVisible(false);

  const staticMenuData = [
    { title: 'Features', id: 'features' },
    { title: 'Customer Stories', id: 'customer-stories' },
    { title: 'FAQs', id: 'faq' }
  ];


  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      mobileSubMenClose(); // optionally close mobile menu after click
    }
  };
  return (
    <div className="">
      <Helmet>
        <title>
          Alternate - KwikEngage – WhatsApp Commerce for D2C Brands | Recover Carts & Drive Sales
        </title>
        <meta name="description" content='KwikEngage - no-code WhatsApp engagement suite — Helping fast-growing D2C brands in the UK to reduce drop-offs, increase repeat sales, and deliver world-class support.' />

        <meta name="keywords" content='WhatsApp commerce UK, Shopify WhatsApp marketing, abandoned cart recovery WhatsApp, D2C UK WhatsApp, KwikEngage UK, WhatsApp support for Shopify brands'></meta>
      </Helmet>

      {
        !isMobile ? (
          <header id="header" className="header header1 d-flex align-items-center " style={{
            backgroundColor: "#FCF5EB",
            fontWeight: "300",
            position: "sticky",     // makes it sticky
            top: 0,                  // stick to top
            zIndex: 999,
          }}>
            <div className="container-fluid d-flex align-items-center justify-content-between">
              <Link
                to="/"
                className="logo d-flex align-items-center me-auto me-lg-0"
                style={{ visibility: isKwikCheckoutCOD ? 'hidden' : 'visible' }}
              >
                <img
                  src="/assets/images/logo2.png"
                  width="137"
                  height="40"
                  alt="GoKwik"
                />
              </Link>
              <nav id="navbar" className={navbarVisible ? 'navbar show' : 'navbar'}>
                <ul>
                  {
                    staticMenuData.map((item, index) => (
                      <li key={index} style={{}}>
                        <a
                          onClick={(e) => {
                            e.preventDefault(); // prevent default anchor jump
                            scrollToSection(item.id);
                          }}
                          href={`#${item.id}`}
                          className={location.hash === `#${item.id}` ? 'active' : ''}
                        >
                          {item.title}
                        </a>
                      </li>

                    ))}
                </ul> </nav>
              <button onClick={scrollToTop} className="cta1 flex items-center gap-2">
                Book a Demo
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" width="16" height="16" fill="none" stroke="#232326" strokeWidth="2">
                  <path d="M17.5 6.7 L23 12.2 L17.5 17.8" />
                  <line x1="23" y1="12.2" x2="1" y2="12.2" />
                </svg>
              </button>
              {navbarVisible ? (
                <i
                  onClick={mobileToggle}
                  className="mobile-nav-toggle mobile-nav-hide fa-solid fa-xmark"
                ></i>
              ) : (
                <i
                  onClick={mobileToggle}
                  className="mobile-nav-toggle mobile-nav-show fa-solid fa-bars-staggered"

                ></i>
              )}
            </div>


          </header>) : (
          <header id="header" className="header header-mob d-flex align-items-center " style={{
            backgroundColor: "#FCF5EB",
            fontWeight: "300",
            top: 0,                  // stick to top
            zIndex: 999,
             width:'100%',
            position: "fixed",    
          }}>
            <div className="container-fluid d-flex align-items-center justify-content-between">
              <Link
                to="/"
                className="logo d-flex align-items-center me-auto me-lg-0"
                style={{ visibility: isKwikCheckoutCOD ? 'hidden' : 'visible' }}
              >
                <img
                  src="/assets/images/logo2.png"
                  width="137"
                  height="40"
                  alt="GoKwik"
                />
              </Link>

              <nav id="navbar" className={navbarVisible ? 'navbar show' : 'navbar'}>
                <ul>
                  {
                    staticMenuData.map((item, index) => (
                      <li key={index} style={{}}>
                        <a
                          onClick={(e) => {
                            e.preventDefault(); // prevent default anchor jump
                            scrollToSection(item.id);
                          }}
                          href={`#${item.id}`}
                          className={location.hash === `#${item.id}` ? 'active' : ''}
                        >
                          {item.title}
                        </a>
                      </li>

                    ))}
                </ul>
              </nav>  <button onClick={scrollToTop} className="cta1-mob flex items-center gap-2">
                Book a Demo
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" width="16" height="16" fill="none" stroke="#232326" strokeWidth="2">
                  <path d="M17.5 6.7 L23 12.2 L17.5 17.8" />
                  <line x1="23" y1="12.2" x2="1" y2="12.2" />
                </svg>
              </button>{navbarVisible ? (
                <i
                  onClick={mobileToggle}
                  className="mobile-nav-toggle mobile-nav-hide fa-solid fa-xmark"
                ></i>
              ) : (
                <i
                  onClick={mobileToggle}
                  className="mobile-nav-toggle mobile-nav-show fa-solid fa-bars-staggered"

                ></i>
              )}
            </div>


          </header>)
      }

      <SectionOne />
      <SectionTwo />
      <div id="customer-stories">
        <SectionThree />
      </div>
      <div id="features">
        <SectionFour />
      </div>
      <div id="faq" style={{ backgroundColor: "#fff7e6" }}>
        <SectionFive />
      </div>



    </div>
  );
};

export default KEInternational;
